module.exports = __webpack_public_path__ + "static/media/logo--en.adc183b2.svg";